export default "__VITE_ASSET__BckDOc8Y__"